import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { modalClosed, modalOpened } from './modalActions';

/** Keeps a mounted modal registered as the active modal in Redux. */
export const useActiveModal = (modalId: string): void => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(modalOpened(modalId));

        return () => {
            dispatch(modalClosed(modalId));
        };
    }, [dispatch, modalId]);
};

export default useActiveModal;
